import cs from './messages_cs.json';
import de from './messages_de.json';
import en from './messages_en.json';
import pl from './messages_en.json';
import es from './messages_es.json';
import fr from './messages_fr.json';
import hu from './messages_hu.json';
import id from './messages_id.json';
import it from './messages_it.json';
import ja from './messages_ja.json';
import pt from './messages_pt.json';
import ro from './messages_ro.json';
import ru from './messages_ru.json';
import th from './messages_th.json';
import tr from './messages_tr.json';
import uk from './messages_uk.json';
import zh_CN from './messages_zh-CN.json';
import zh_HK from './messages_zh-HK.json';
export const comparisonSelfServeMessages = {
    cs,
    de,
    en,
    pl,
    es,
    fr,
    hu,
    id,
    it,
    ja,
    pt,
    ro,
    ru,
    th,
    tr,
    uk,
    'zh-HK': zh_HK,
    'zh-CN': zh_CN,
};
